/**
 * The frames available to try on.
 *
 * Orientation is auto-detected by normalize-model.js — no per-model rotation
 * calibration is needed.
 *
 * Calibration fields, all consumed by normalize-model.js and the try-on scene:
 *
 *   offsetY     Nudge along the face's up axis, in frame-widths. Positive lifts.
 *   offsetZ     Nudge along the face's forward axis. Positive pushes it away.
 *   widthRatio  Frame width as a multiple of measured face width.
 */
export const frames = [
  {
    id: "meridian",
    name: "Meridian",
    shape: "Wayfarer",
    modelUrl: "/assets/glasses-1.glb",
    // normalize-model.js puts the origin at the lens centres, so the only
    // vertical correction left is the gap from there down to the eye line:
    // ~0.044 face widths on a reference face, 0.03 frame widths at this
    // widthRatio. Verified end-to-end within half a pixel across all three
    // catalog frames (see _vto_tmp/e2e-eye.mjs).
    calibration: { rotationY: -Math.PI / 2, offsetY: -0.03, offsetZ: 0, widthRatio: 0.93 },
  },
  {
    id: "atlas",
    name: "Atlas",
    shape: "Rectangle",
    modelUrl: "/assets/glasses-2.glb",
    // Same eye-line drop as Meridian; the lens-centre origin makes the
    // correction model-independent, where the old bounding-box origin needed
    // a per-model nudge to compensate where each model's lenses happened to
    // sit inside its box.
    calibration: { offsetY: -0.03, offsetZ: 0, widthRatio: 0.95 },
  },
  {
    id: "horizon",
    name: "Horizon",
    shape: "Round",
    modelUrl: "/assets/glasses-3.glb",
    // Same axis layout and eye-line drop as the other two.
    calibration: { offsetY: -0.03, offsetZ: 0, widthRatio: 0.94 },
  },
];
